export function supportsTouchInput() {
    return window.matchMedia('(any-pointer: coarse)').matches;
}

export default class FocusToggle {
    static CONTAINER_ID = 'focus-toggle-container';
    static INPUT_ID = 'focus-toggle';
    static LABEL_ID = 'focus-toggle-label';

    constructor(eventBus) {
        this.eventBus = eventBus;
        this.container = document.getElementById(FocusToggle.CONTAINER_ID);
        this.input = document.getElementById(FocusToggle.INPUT_ID);
        this.label = document.getElementById(FocusToggle.LABEL_ID);
        this.handleChangeBound = this.handleChange.bind(this);

        this.setVisible(true);

        if (this.input) {
            this.input.addEventListener('change', this.handleChangeBound);
            this.setEnabled(false, false);
        }
    }

    setVisible(visible) {
        if (!this.container) return;
        this.container.classList.toggle('hidden', !visible);
    }

    getState() {
        return !!this.input?.checked;
    }

    setState(checked, emit = true) {
        if (!this.input) return false;
        const nextState = !!checked;
        this.input.checked = nextState;
        if (emit) this.emitChanged(nextState);
        return nextState;
    }

    setEnabled(enabled, emit = true) {
        const isEnabled = !!enabled;

        if (this.input) {
            this.input.disabled = !isEnabled;
        }

        if (this.label) {
            this.label.classList.toggle('pointer-events-none', !isEnabled);
            this.label.classList.toggle('pointer-events-auto', isEnabled);
            this.label.classList.toggle('opacity-35', !isEnabled);
        }

        if (!isEnabled && this.getState()) {
            this.setState(false, emit);
        }

        return isEnabled;
    }

    handleChange() {
        this.emitChanged(this.getState());
    }

    emitChanged(checked) {
        this.eventBus.pushLocal('focusToggleChanged', { checked: !!checked });
    }

    destroy() {
        if (this.input) {
            this.input.removeEventListener('change', this.handleChangeBound);
            this.input = null;
        }
        this.container = null;
        this.label = null;
    }
}
